
import { useEffect } from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const QR_CODE_WEBSITE = "https://expiqr.vercel.app/";

const ExternalQRTab = () => {
  const handleRedirect = () => {
    window.open(QR_CODE_WEBSITE, "_blank");
  };

  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4">
      <div className="text-center max-w-md">
        <h3 className="text-lg font-medium mb-2">QR Code Scanner</h3>
        <p className="text-sm text-gray-600 mb-4">
          Our QR code scanning functionality is now available on a dedicated website for improved performance and reliability.
        </p>
        <Button
          onClick={handleRedirect}
          className="bg-emerald-600 hover:bg-emerald-700 w-full"
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          Open QR Code Scanner
        </Button>
        <p className="text-xs text-gray-500 mt-3">
          You will be redirected to our secure QR code scanning website.
        </p>
      </div>
    </div>
  );
};

export default ExternalQRTab;
